import { createReducer, on } from '@ngrx/store';
import { OverviewTemplateActions } from './overview.actions';
import { Section } from './model/overview.model';

export interface OverviewState {
  loading: boolean;
  error: string;
  sections: Section[];
}

export const initialState: OverviewState = {
  loading: false,
  error: '',
  sections: [],
};

export const overviewReducer = createReducer(
  initialState,
  on(OverviewTemplateActions.loadSections, state => ({
    ...state,
    loading: true,
  })),
  on(OverviewTemplateActions.setSections, (state, { sections }) => ({
    ...state,
    sections,
    loading: false,
  }))
);
